// src/utils/contactUtils.js
// Utility condivise per la gestione contatti e tracking click

const API_NODE_BASE = (process.env.REACT_APP_API_URL_NODE || 'http://localhost:3002').replace(/\/$/, '');

// ─── Normalizzazione numeri ───────────────────────────────────────────────────

export function splitPhones(raw) {
    if (!raw) return [];
    return String(raw).split(/[,;|/]|(?:\s+\/\s+)/g).map(s => s.trim()).filter(Boolean);
}

export function normalizeDigits(phone) {
    if (!phone) return '';
    let digits = String(phone).replace(/[^\d]/g, '');
    if (digits.startsWith('0039')) digits = '39' + digits.slice(4);
    if (digits.length === 10 && digits.startsWith('3')) digits = '39' + digits;
    return digits;
}

export function isItalianMobileDigits(digits) {
    if (!digits) return false;
    if (digits.startsWith('39')) return digits.slice(2).startsWith('3');
    return digits.startsWith('3');
}

/**
 * Restituisce true se il numero di telefono è un cellulare italiano.
 */
export function isMobileNumber(phone) {
    if (!phone) return false;
    return isItalianMobileDigits(normalizeDigits(phone));
}

/**
 * Normalizza un numero per WhatsApp.
 * Restituisce la stringa di cifre (es. "393XXXXXXXX") o null se non è un cellulare.
 */
export function normalizeToWhatsappDigits(phone) {
    const digits = normalizeDigits(phone);
    return isItalianMobileDigits(digits) ? digits : null;
}

/**
 * Costruisce l'URL wa.me con messaggio precompilato.
 * @param {string} phone - numero grezzo
 * @param {string} name  - nome dell'attività / POI
 */
export function buildWhatsappUrl(phone, name) {
    const digits = normalizeToWhatsappDigits(phone);
    if (!digits) return null;
    const text = encodeURIComponent(`Ciao, ti contatto da AI Hiking per: ${name || 'questa attività'}`);
    return `https://wa.me/${digits}?text=${text}`;
}

// ─── Tracking click ───────────────────────────────────────────────────────────

/**
 * Tracking fire-and-forget per i POI regionali (sistema /go/*).
 * @param {'phone'|'email'|'website'} type
 * @param {string} osmid  - id OSM già normalizzato (senza node/way/relation)
 * @param {number|string} lat
 * @param {number|string} lng
 */
export function trackPoiContact(type, osmid, lat, lng) {
    const url = `${API_NODE_BASE}/go/${type}?osmid=${encodeURIComponent(osmid)}&lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;
    fetch(url, { method: 'GET', keepalive: true })
        .catch(err => console.warn(`[trackPoiContact:${type}] error:`, err.message));
}

/**
 * Tracking fire-and-forget per le attività di area (sistema /go/contact).
 * @param {'whatsapp'|'phone'|'email'|'website'|'maps'} type
 * @param {string} entityId
 * @param {string} entityType  - es. "activity"
 * @param {string} placement   - es. "map_popup", "list_card"
 */
export function trackActivityContact(type, entityId, entityType, placement) {
    const base = `${API_NODE_BASE}/go/contact`;
    const url = `${base}?type=${type}&entityType=${entityType}&id=${encodeURIComponent(entityId)}&placement=${placement}`;
    fetch(url, { method: 'GET', keepalive: true })
        .catch(err => console.warn(`[trackActivityContact:${type}] error:`, err.message));
}

export { API_NODE_BASE };
